import { render } from "./TicketMessageComponent.vue?vue&type=template&id=5fe6fd1e&ts=true"
import script from "./TicketMessageComponent.vue?vue&type=script&lang=ts"
export * from "./TicketMessageComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__